import { FunctionComponent, useMemo, type JSX } from 'react';

import { useSelector } from '@/api/state';
import { getUserRoles } from '@/utils/stateAccessors';
import { AnnouncementBanner } from '@payaca/components/announcementBanner/AnnouncementBanner';
import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';
import { userHasRequiredPermission } from '@payaca/permissions/permissions.utils';
import { Link } from 'react-router-dom';
import { PermissionGuard } from '../permissionGuard/PermissionGuard';
import './UserSeatsExceededBanner.css';

const UserSeatsExceededBanner: FunctionComponent = (): JSX.Element | null => {
  const userRoles = useSelector(getUserRoles);
  const currentUserIsAdmin = useMemo(() => {
    return userHasRequiredPermission(userRoles, [
      AccountsPermissions.UPDATE_SUBSCRIPTION,
    ]);
  }, [userRoles]);

  const isOnManageSubscriptionPage = useMemo(() => {
    return location.pathname == '/upgradeAccount';
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useMemo has an unnecessary dependency: location.
  }, [location]);

  return (
    <AnnouncementBanner>
      <div className="flex flex-row items-baseline gap-4">
        <span className="mr-auto text-white">
          The number of users exceeds the user capacity of this account.{' '}
          {!currentUserIsAdmin && 'Please contact your account administrator.'}
        </span>
        {!isOnManageSubscriptionPage && (
          <PermissionGuard
            renderIfHasPermissions={[AccountsPermissions.UPDATE_SUBSCRIPTION]}
          >
            <Link to="/upgradeAccount">
              <AnnouncementBanner.Button>
                Add more users
              </AnnouncementBanner.Button>
            </Link>
          </PermissionGuard>
        )}
      </div>
    </AnnouncementBanner>
  );
};

export default UserSeatsExceededBanner;
